import {
  setAvailableTopics,
  setContentFilesExercises,
  setSuggestedTopicsByTeachers,
} from "../slices/contentExercises.slice";
import api from "../../services/api";
import { initLoading, endLoading } from "../slices/generics.slice";

const CONTENT_FILES_EXERCISES = "/contentFilesExercises";

const languageById = { 1: "EN", 2: "ES", 3: "PT", 4: "FR", 101: "EN" };

export const getAvailableTopics = (lingoLanguageId) => {
  return async (dispatch) => {
    const params = new URLSearchParams();
    params.set("language", languageById[lingoLanguageId]);

    try {
      dispatch(initLoading());

      const response = await api.get(`${CONTENT_FILES_EXERCISES}/getAvailableTopics?${params}`);

      if (!response.data.success) return;
      const items = response?.data?.result?.items || [];
      dispatch(setAvailableTopics(items));
      return items;
    } catch (error) {
      console.log("getAvailableTopics", error);
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getAvailableTopicsByLevel = (payload) => {
  return async (dispatch) => {
    const params = new URLSearchParams();
    params.set("currentLevel", payload.currentLevel);
    params.set("currentCycle", payload.currentCycle);
    params.set("language", languageById[payload.lingoLanguageId]);

    if (payload.lingoLanguageId === 101) return [];

    try {
      const response = await api.get(`${CONTENT_FILES_EXERCISES}/getAvailableTopicsByLevel?${params}`);

      if (!response.data.success) return;
      const items = response?.data?.result?.items || [];
      dispatch(setAvailableTopics(items));
      return items;
    } catch (error) {
      console.log("getAvailableTopics", error);
      return false;
    }
  };
};

export const getSuggestedTopicsByTeacher = (payload) => {
  return async (dispatch) => {
    const params = new URLSearchParams();
    params.set("studentId", payload.studentId);
    params.set("language", languageById[payload.lingoLanguageId]);

    try {
      const response = await api.get(`${CONTENT_FILES_EXERCISES}/getSuggestedTopicsByTeacher?${params}`);
      const items = response?.data?.result?.items || [];
      dispatch(setSuggestedTopicsByTeachers(items));
      return items;
    } catch (error) {
      console.log("getSuggestedTopicsByTeacher", error);
      return false;
    }
  };
};

export const createContentExercises = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const newPayload = { ...payload, language: payload.language === "CS-US-IN" ? "EN" : payload.language };

      const response = await api.post(`${CONTENT_FILES_EXERCISES}/createContentExercises`, newPayload);
      return response?.data?.result?.items || [];
    } catch (error) {
      console.log("createContentExercises", error);
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getContentExercises = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const params = new URLSearchParams();
      if (payload.limit != null) params.set("limit", String(payload.limit));
      if (payload.userId != null) params.set("userId", String(payload.userId));
      if (payload.active != null) params.set("active", String(payload.active));
      if (payload.status != null) params.set("status", String(payload.status));
      if (payload.finished != null) params.set("finished", String(payload.finished));
      if (payload.language != null) {
        params.set("language", String(payload.language === "CS-US-IN" ? "EN" : payload.language));
      }

      const response = await api.get(`${CONTENT_FILES_EXERCISES}/get?${params.toString()}`);
      if (!response.data?.success) return false;

      dispatch(setContentFilesExercises(response?.data?.result?.items || []));
    } catch (error) {
      console.log("getContentExercises", error);
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const duplicateContentExercises = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.post(`${CONTENT_FILES_EXERCISES}/duplicate`, payload);
      return response?.data?.result?.items[0] || [];
    } catch (error) {
      console.log("duplicateContentExercises", error);
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const regenerateContentExercises = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.post(`${CONTENT_FILES_EXERCISES}/regenerate`, payload);
      return response?.data?.result?.items[0] || [];
    } catch (error) {
      console.log("duplicateContentExercises", error);
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};
